import React, { useEffect } from 'react';
import { requestHostWindowLayout } from '../../../shared/lib/utils/windowSizing';
import MappingConfigurationContainer from './MappingConfigurationContainer';
import type { MappingConfigurationPageProps } from './MappingConfigurationContainer';

const MappingConfigurationPage: React.FC<MappingConfigurationPageProps> = (props) => {
  useEffect(() => {
    requestHostWindowLayout('CenterPanel');
  }, []);

  return <MappingConfigurationContainer {...props} />;
};

export default React.memo(MappingConfigurationPage);
